import axios from 'axios';
import {backendHost} from '../../config';

export const postRole = (params) => {
    return axios.post(`${backendHost}/api/partners/admin/roles`, params);
};